export const VALID_ROLES = ['radiologist', 'staff_radiologist', 'coordinator'];

export const VALID_MAINTENANCE_ROLES = ['bypass_maintenance'];

export const PII_ROLE = 'pii';
